module.exports = __webpack_public_path__ + "static/media/physalina-logo-slogan.05b8e7b6.svg";